import styled from 'styled-components';
import colors from '../../../../../styles/colors';

const StyledPricingTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 8px;

  th,
  td {
    border: 1px solid #ddd;
    padding: 8px 12px;
    text-align: left;
  }

  th {
    background-color: #f5f5f5;
    font-weight: 500;
    font-size: 14px;
  }

  td:first-child {
    background-color: ${colors.shades.alpha2};
    font-weight: 500;
    width: 250px;
  }
  
  td:nth-child(2) {
    width: 200px;
  }

  input {
    width: 100%;
    border: none;
    outline: none;
    background: transparent;
    font-size: 14px;
    padding: 4px;

    &:focus {
      background-color: ${colors.shades.gamma5};
      border-radius: 2px;
    }
  }
`;

export { StyledPricingTable };
